import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputNumberComponent } from 'src/app/shared/components/inputs/input-number/input-number.component';
import { InputTextComponent } from 'src/app/shared/components/inputs/input-text/input-text.component';

@Component({
  selector: 'app-informazioni-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextComponent,
    InputNumberComponent,
  ],
  templateUrl: './informazioni-form.component.html',
  styleUrl: './informazioni-form.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformazioniFormComponent implements OnInit {
  @Input() form!: FormGroup;

  ngOnInit() {
    this.form.addControl('previsioneAbitantiServiti', new FormControl<number>(0, []));
    this.form.addControl('previsionePortata', new FormControl<number>(0, []));
    this.form.addControl('descrizionePunto', new FormControl('', []));
    this.form.addControl('note', new FormControl('', []));
  }
}
